import React, { useContext } from 'react';
import { UnitContext } from '../../../context/UnitContext';
import Scroll from '../../../../Shared/Utility/Scroll';
import LoadingSpinner from '../../../../Shared/components/LoadingSpinner';
import ListView from './ListView';
import MapView from './MapView';
import Alert, { AlertType } from '../../../../Shared/components/Alert';
const View = () => {
    var _a, _b, _c;
    const { state } = useContext(UnitContext);
    const restoreScrollPosition = () => {
        const scrollY = sessionStorage.getItem('dwellingCardScrollY');
        if (scrollY) {
            Scroll.to(0, parseInt(scrollY));
            sessionStorage.removeItem('dwellingCardScrollY');
        }
    };
    if (state.loading || state.reloadNeeded) {
        return React.createElement(LoadingSpinner, null);
    }
    let searchRadius = null;
    if ((_b = (_a = state.chosenUserFilters) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.point) {
        searchRadius = {
            center: {
                lng: state.chosenUserFilters.location.point.lng,
                lat: state.chosenUserFilters.location.point.lat,
            },
            radius: parseInt((_c = state.chosenUserFilters.location) === null || _c === void 0 ? void 0 : _c.distance) * 1000,
        };
    }
    if (state.units.length) {
        restoreScrollPosition();
        switch (state.currentView) {
            case 'tiles':
            case 'list':
                return React.createElement(ListView, { units: state.units });
            case 'map':
                return React.createElement(MapView, { units: state.units, searchRadius: searchRadius });
            default:
                return React.createElement(Alert, { title: "t(unknownError)", type: AlertType.error });
        }
    }
    return (React.createElement("div", { className: "zds-margin-y-4" },
        React.createElement(Alert, { title: "t(tx_zigrealestate.details.no_object_found)" })));
};
export default View;
